export const EDIT_WEBSITE_CONTENT_BASE_PATH = '/digital-marketing/edit-website-content';

export const buildEditWebsiteContentPath = (subPath = '') => {
    const normalizedSubPath = subPath.replace(/^\/+/, '');

    return normalizedSubPath
        ? `${EDIT_WEBSITE_CONTENT_BASE_PATH}/${normalizedSubPath}`
        : EDIT_WEBSITE_CONTENT_BASE_PATH;
};
